<template>
  <div class="animated fadeIn form-abm">
    <b-row>
      <b-col xl="12">
        <b-card header= "Información del Sorteo Global">
          <b-form>
            <app-cliente
              label="Cliente"
              :nombre="clienteNombre"
              :labelCols="labelCols"
              :valido="clienteValido"
              :lista="clientesList"
              :msjInvalido="clienteInvalidoMsj"
              @validate="validate"
              @updated="clienteActualizado">
            </app-cliente>  

            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                class="text-upper"
                v-model.trim="$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-tipo-evento
              label="Tipo de Evento"
              :nombre="tipoEventoNombre"
              :labelCols="labelCols"
              :valido="tipoEventoValido"
              :lista="tiposEventosList"
              :msjInvalido="tipoEventoInvalidoMsj"
              @validate="validate"
              @updated="tipoEventoActualizado">
            </app-tipo-evento>  

            <b-form-group
              label="Fecha Sorteo"
              label-for="fechaSorteo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaSorteo" 
                v-model="fechaSorteo" 
                type="date">
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Cliente from '../shared/abmSelect.vue';
import TipoEvento from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, requiredIf, numeric, maxLength, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'sorteoGlobal/getField',
  mutationType: 'sorteoGlobal/updateField',
});

export default {
  name: 'SorteoGlobalABM',
  components: {
    appCliente: Cliente,
    appTipoEvento: TipoEvento,
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      clienteValido: null,
      clienteInvalidoMsj: '',
      nombreValido: null,
      nombreInvalidoMsj: '',
      tipoEventoValido: null,
      tipoEventoInvalidoMsj: '',

      clientes: [],
      clientesList: [],
      tiposEventos: [],
      tiposEventosList: [],

      labelCols: 2,
      loading: false,
      loadingClientes: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      'cliente',
      'clienteNombre',
      'fechaSorteo',
      'nombre',
      'tipoEvento',
      'tipoEventoNombre',
    ]),
  },  
  created() {
    let sorteoGlobalId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        sorteoGlobalId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.loading = true;
    this.loadinClientes = true;
    this.$store.dispatch('sorteoGlobal/inicializar', sorteoGlobalId)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      this.tiposEventos = [
        {
          id: 1,
          nombre: 'PWA'
        },
        {
          id: 2,
          nombre: 'PORTAL'
        }
      ];
      this.tiposEventosList = [ 'PWA', 'PORTAL' ];
      this.loading = false;

      this.$store.dispatch('clientes/getList')
        .then(() => {
          this.clientes = this.$store.getters['clientes/list']
          this.clientesList = this.$store.getters['clientes/selectList']
          this.loadingClientes = false;
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de clientes')))
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj= 'Debe ingresar el nombre comercial.';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      let clienteError = true;
      if (this.cliente) {
        if (this.cliente.id) {
          if (this.cliente.id != 0) {
            clienteError = false;
          }
        }
      }
      if (clienteError) {
        this.clienteValido = false;
        this.clienteInvalidoMsj = 'Debe seleccionar el cliente correspondiente.';
        save = false;
      }

      let tipoEventoError = true;
      if (this.tipoEvento) {
        if (this.tipoEvento.id) {
          if (this.tipoEvento.id != 0) {
            tipoEventoError = false;
          }
        }
      }
      if (tipoEventoError) {
        this.tipoEventoValido = false;
        this.tipoEventoInvalidoMsj = 'Debe seleccionar el tipo de evento correspondiente.';
        save = false;
      }

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('sorteoGlobal/save')
            .then(()  => this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        } 
      }
    },
    objetoValido(objeto, objetoNombre, objetoList, objetoDispatch, validar, 
        objetoValido, objetoInvalidoField, objetoInvalidoMsj) {
      let isValido = true;
      let selected = null;
      if (objetoNombre) {
        selected = this.getSelected(objetoList, objetoNombre);
      }
      this.$store.dispatch('sorteoGlobal/' + objetoDispatch, selected);

      let objetoStore = this.$store.getters['sorteoGlobal/' + objeto];

      if (validar) {
        if (objetoStore) {
          if (objetoStore.id) {
            if (objetoStore.id != 0) {
              isValido = false;
            }
          }
        }
        if (!isValido) {
          objetoValido = false;
          objetoInvalidoField = objetoInvalidoMsj;
        }
      }
      return isValido;
    },
    goBack() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.push({ name: "SorteosGlobales" });
    },
    clienteActualizado(clienteNombre) {
      if (!this.loadingClientes) {
        this.clienteNombre = clienteNombre;

        let cliente;
        if (clienteNombre) {
          cliente = this.getSelected(this.clientes, clienteNombre);
        }
        this.$store.dispatch('sorteoGlobal/setCliente', cliente);

        this.clienteValido = null;
        this.clienteInvalidoMsj = '';
      }
    },
    tipoEventoActualizado(tipoEventoNombre) {
      if (!this.loading) {
        this.tipoEventoNombre = tipoEventoNombre;

        let tipoEvento;
        if (tipoEventoNombre) {
          tipoEvento = this.getSelected(this.tiposEventos, tipoEventoNombre);
        }
        this.$store.dispatch('sorteoGlobal/setTipoEvento', tipoEvento);

        this.tipoEventoValido = null;
        this.tipoEventoInvalidoMsj = '';
      }
    },
  },
  watch: {
  },
  validations: {
    nombre: {
      required,
      maxLength: maxLength(255)
    },
  },  
}
</script>

<style>
</style>
